export const ENTITLEMENTS = {
  FREE: {
    CHARTS: 3,
    DASHBOARDS: 3,
    DATASETS: 3,
  },
  PRO: {
    CHARTS: Infinity,
    DASHBOARDS: Infinity,
    DATASETS: Infinity,
  },
  API: {
    CHARTS: Infinity,
    DASHBOARDS: Infinity,
    DATASETS: Infinity,
  },
}
